import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProjects(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/projects/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProject(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/projects/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editProject(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/projects", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProject(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/projects", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateProjectRecord(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/projects/record", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectRecord(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/projects/record", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteProjectDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_documents", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    fetchQuotation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/quotations/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchInvoice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/finance/invoices/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    deleteProjectDocumentFile(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/project_documents/files", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editProjectActivitice(ctx, data) {
       return new Promise((resolve, reject) => {
         axiosIns
           .post(`/project_activities`, data)
           .then((response) => resolve(response))
           .catch((error) => reject(error));
       });
     },
     deleteProjectActivitice(ctx, queryParams) {
       return new Promise((resolve, reject) => {
         axiosIns
           .delete("/project_activities", { params: queryParams })
           .then((response) => resolve(response))
           .catch((error) => reject(error));
       });
     },
  }
};
